import React, { FocusEvent } from "react"
import { ErrorMessage } from "../../common/general-styles.component"
import { uniqueId } from "lodash"
import Textarea from "./textarea.component"
import { TextareaWithErrorProps } from "./textarea.interface"
import { AppFunctionComponent } from "../../../types"

const TextareaWithError: AppFunctionComponent<TextareaWithErrorProps> = ({
  className,
  error,
  onFocus,
  onBlur,
  ...props
}) => {
  const focus = (event: FocusEvent<HTMLTextAreaElement>) => {
    if (onFocus) {
      onFocus(event)
    }
  }

  const blur = (event: FocusEvent<HTMLTextAreaElement>) => {
    if (onBlur) {
      onBlur(event)
    }
  }

  const errorId = `id-${uniqueId()}-error`

  return (
    <>
      <Textarea
        {...props}
        error={error}
        onFocus={focus}
        onBlur={blur}
        aria-describedby={errorId}
        className={className}
      />
      {error && <ErrorMessage id={errorId}>{error}</ErrorMessage>}
    </>
  )
}

export default TextareaWithError
